<!-- <div class="matDialogTitle" matDialogTitle>
    <div class="flex justify-between">
        <h2 class="m-0"></h2>
        <div>
            <button mat-icon-button (click)="_matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div> -->

<mat-dialog-content
  class="dialog-body !max-w-[790px]"
  mat-dialog-content
  class="!px-[30px] !pb-[10px] relative m-0"
  fusePerfectScrollbar
>
  <div class="absolute -top-1 right-2">
    <button
      mat-icon-button
      (click)="_matDialogRef.close()"
      aria-label="Close dialog"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="md:px-20 px-0">
    <div class="grid stepper-wrapper items-start grid-cols-3 mb-8 mt-4">
      <ng-container *ngFor="let item of this.stepData; let i = index">
        <div
          class="flex relative z-10"
          [ngClass]="
            i == 0
              ? 'justify-start'
              : i == 1
              ? 'justify-center'
              : i == 2
              ? 'justify-end'
              : ''
          "
        >
          <div
            class="flex flex-col gap-2 items-center justify-center"
            [ngClass]="
              item.status == 1
                ? 'running-step'
                : item.status == 2
                ? 'upcomming-step'
                : item.status == 3
                ? 'completed-step'
                : ''
            "
          >
            <div
              class="w-8 bg-white-color h-8 flex text-base font-semibold justify-center items-center border rounded-full"
            >
              <ng-container *ngIf="item.status != 3">{{
                item.id
              }}</ng-container>
              <ng-container *ngIf="item.status == 3">
                <mat-icon class="mat-18 text-white-color">done</mat-icon>
              </ng-container>
            </div>
            <p
              class="sm:text-sm text-center text-xs font-medium sm:leading-5 leading-3"
            >
              {{ item.title }}
            </p>
          </div>
        </div>
      </ng-container>
      <div class="absolute w-full px-[60px] top-[18px] z-0">
        <div class="w-full h-[1px] border-t border-dotted border-[#7C8390]"></div>
      </div>
    </div>
  </div>

  <div class="steps-wrapper">
    <ng-container *ngFor="let step of this.stepData">
      <div *ngIf="step.status == 1" class="stepItemHeaderWrapper mb-6">
        <div class="stepItemHeader">
          <!-- <span>{{step.id}}</span> -->
          <!-- <h3>{{step.title}}</h3> -->
        </div>
        <p class="text-sm" [innerHTML]="step.des"></p>
        <button
          *ngIf="!this.data?.length"
          class="downloadSampleFile"
          style="
            max-height: 38px;
            color: green;
            border: 0;
            background: transparent;
            cursor: pointer;
            padding: 3px 0;
            font-size: 14px;
          "
          (click)="downloadSampleFile()"
        >
          {{ "Download Sample File (see how to organize your data)" }}
        </button>
        <span
          class="sm:text-sm text-xs text-black-color font-semibold"
          *ngIf="step?.warring"
          >{{ step.warring }}</span
        >
      </div>

      <!-- step 1 -->
      <div class="stepItem" *ngIf="step.status === 1">
        <!-- <div class="stepItemHeaderWrapper">
                    <div> 
                        <p *ngIf="!this.data?.length">{{step.des}}</p>
                        <p *ngIf="this.data?.length">Review the information below to ensure it is correct. If any changes are needed, edit your file and upload it again.</p>
                    </div>
                    <button *ngIf="!this.data?.length" class="downloadSampleFile" style="max-height: 38px; color: green; border: 0; background: transparent; cursor: pointer; padding: 3px 0;" (click)="downloadSampleFile()">{{'Download Sample File (see how to organize your data)'}}</button>
                </div> -->

        <div class="stepBody" *ngIf="!this.data?.length; else showDataTable">
          <form [formGroup]="this.form">
            <input
              (change)="this.onFileChange($event)"
              multiple="false"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              id="getFile"
              style="display: none"
              type="file"
            />
            <input formControlName="file" style="display: none" />
            <div
              matRipple
              class="file-upload-btn"
              for="files"
              onclick="document.getElementById('getFile').click()"
            >
              <ngx-file-drop
                dropZoneLabel="Drop files here"
                class="fileDrop"
                (onFileDrop)="this.dropped($event)"
              >
                <ng-template
                  ngx-file-drop-content-tmp
                  let-openFileSelector="openFileSelector"
                >
                  <div
                    class="flex flex-col items-center justify-center gap-[15px]"
                  >
                    <img
                      src="assets/images/ui/CSV-hd-icon.svg"
                      alt=""
                      class="w-[40px] h-[50px]"
                    />
                    <p class="text-sm font-medium text-blue-theme-color">
                      Upload CSV File for Drop-offs
                    </p>
                  </div>
                </ng-template>
              </ngx-file-drop>
            </div>
          </form>
        </div>

        <!-- show data -->
        <ng-template #showDataTable>
          <ng-container *ngIf="this.stepData[1].status == 1">
            <div class="excelTable" *ngIf="this.data?.length">
              <table>
                <ng-container *ngFor="let dataRow of this.data; let i = index">
                  <tr class="dataRow">
                    <ng-container *ngFor="let dataCode of dataRow">
                      <th style="text-align: left" *ngIf="i == 0">
                        <span>{{ dataCode }}</span>
                      </th>
                      <td *ngIf="i != 0">
                        <span>{{ dataCode }}</span>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </table>
            </div>
            <p class="text-sm my-3 font-semibold text-red">
              Ensure all data is correct. If anything looks wrong, please upload
              an updated CSV file.
            </p>
          </ng-container>
        </ng-template>
      </div>

      <!-- step 2 -->
      <div class="stepItem" *ngIf="step?.status == 1">
        <!-- <div class="stepItemHeaderWrapper">
                    <div class="stepItemHeader">
                        <span>{{step.id}}</span>
                        <h3>{{step.title}}</h3>
                    </div>
                    <p [innerHTML]="step.des"></p>
                    <span class="text-rose-500" *ngIf="step?.warring">{{step.warring}}</span>
                </div> -->

        <!-- mapping tabel -->
        <div class="mappingTabelWrapper">
          <ng-container
            *ngFor="let col of this.mappingTableData; let i = index"
          >
            <div class="mappingItem">
              <div class="mappingHeader sm:flex hidden" *ngIf="i == 0">
                <h5>Columns</h5>
                <h5>Data</h5>
                <h5>Variables</h5>
              </div>
              <div class="mappingRow flex sm:gap-0 gap-3 sm:flex-row flex-col">
                <div class="mappingLabel">
                  <span class="inline sm:hidden">Column : </span>
                  <span
                    >{{
                      col.colName ? (col.colName.toString() | titlecase) : ""
                    }}
                    <span style="color: #f50000" *ngIf="col.isRequired"
                      >*</span
                    ></span
                  >
                </div>
                <div class="mappingData mappingLabel mr-5 overflow-hidden">
                  <span class="inline sm:hidden">Data : </span>
                  <ng-container
                    *ngFor="
                      let data of col.data | slice : 0 : 3;
                      let dataIndex = index
                    "
                  >
                    <h4 class="inline-block !pr-2 sm:pr-0 sm:block">
                      {{ data }}{{ dataIndex != 2 ? " | " : "" }}
                    </h4>
                  </ng-container>
                </div>
                <div class="mappingSelect">
                  <div
                    class="status-drp w-full mappingLabel"
                    [formGroup]="this.optionForm"
                  >
                    <span class="inline mappingLabel sm:hidden"
                      >Variables
                    </span>
                    <mat-select
                      class="border w-full py-2 border-gray-color px-2 rounded"
                      placeholder="Select field for columns"
                      [formControlName]="col.colName"
                      [(value)]="col.selected"
                      (selectionChange)="
                        this.onChangeColField($event, i, col.options)
                      "
                    >
                      <mat-option
                        *ngFor="let option of col.options; let j = index"
                        [value]="option.id"
                      >
                        {{
                          option?.name
                            ? (option?.name.toString() | titlecase)
                            : ""
                        }}
                      </mat-option>
                    </mat-select>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</mat-dialog-content>
<mat-dialog-actions
  *ngIf="this.data?.length"
  style="padding: 14px 0; display: flex; justify-content: center"
>
  <button
    mat-flat-button
    *ngIf="this.data?.length && this.stepData[1].status == 1"
    class="bg-blue-theme-color text-white-color"
    (click)="onConfirmFile()"
  >
    Confirm and Continue
  </button>
  <button
    mat-flat-button
    *ngIf="this.stepData[2].status == 1"
    [disabled]="!this.formValidator()"
    class="bg-blue-theme-color text-white-color"
    (click)="onImportContact()"
  >
    Confirm Import
  </button>
</mat-dialog-actions>
